import { batchProcessorTrigger } from './batchProcessorTrigger'

export const initBackgroundUseCaseTriggers = (store) => {
  batchProcessorTrigger(store);
};
